/* eslint-disable */
// @ts-nocheck
import React from 'react';
import Link from './Link';
import { cx } from '@emotion/css';
const BLACK_LIST_PROPS = ['overrideClassName'];
type Props = {
  i13nModel: {};
  overrideClassName?: string;
  className?: string;
};

const CloseButton = (props: Props) => {
  const i13nModel = { ...props.i13nModel, label: 'Modal Close X' };
  const linkClassName = props.overrideClassName || cx('close-modal', props.className);
  const linkProps = { ...props, className: linkClassName, i13nModel };
  BLACK_LIST_PROPS.forEach((blackListedProp) => {
    delete linkProps[blackListedProp];
  });
  return (
    <Link {...linkProps}>
      <i className="material-icons">clear</i>
    </Link>
  );
};

CloseButton.defaultProps = {
  onClick: () => {},
  to: null,
  testid: 'modal-close-x',
  i13nModel: {},
};
export default CloseButton;
